import script from "./AutomationWizardFieldDocumentTypeStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutomationWizardFieldDocumentTypeStatus.vue?vue&type=script&setup=true&lang=ts"

import "./AutomationWizardFieldDocumentTypeStatus.vue?vue&type=style&index=0&id=cde52d22&lang=scss&scoped=true"
import "./AutomationWizardFieldDocumentTypeStatus.vue?vue&type=style&index=1&id=cde52d22&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cde52d22"]])

export default __exports__